import { ReactElement } from 'react'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { Button, Stack, Typography } from '@mui/material'

export type ChangeDecision = 'approved' | 'denied'

interface Props {
  decision: ChangeDecision | undefined
  onDecide: (approved: boolean) => void
}

/** "Ablehnen" / "Freigeben" for one item the agent waits on, or the decision once made. */
const DecisionButtons = ({ decision, onDecide }: Props): ReactElement => (
  <Stack direction="row" spacing={1} mt={1} justifyContent="flex-end">
    {decision ? (
      <Typography variant="caption" color={decision === 'approved' ? 'success.main' : 'error.main'}>
        {decision === 'approved' ? 'Freigegeben' : 'Abgelehnt'}
      </Typography>
    ) : (
      <>
        <Button
          size="small"
          color="inherit"
          startIcon={<CloseIcon fontSize="small" />}
          onClick={() => onDecide(false)}
          data-cy="ai-chat-change-deny"
        >
          Ablehnen
        </Button>
        <Button
          size="small"
          variant="contained"
          startIcon={<CheckIcon fontSize="small" />}
          onClick={() => onDecide(true)}
          data-cy="ai-chat-change-approve"
        >
          Freigeben
        </Button>
      </>
    )}
  </Stack>
)

export default DecisionButtons
